import { render, staticRenderFns } from "./login.component.vue?vue&type=template&id=65e1469b"
import script from "./login.component.vue?vue&type=script&lang=js"
export * from "./login.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports